import React from 'react';
import { makeStyles, Grid, Box } from '@material-ui/core';

import Typography from '#web-components/components/Typography';

import Info from './components/Info';
import styles from './EntityInfo.styles';

const useStyles = makeStyles(styles, { name: 'EntityInfo' });

interface Props {
  title: string;
  data: Array<{ label: string; value: string; dataXpath?: { caption?: string; text?: string }; }>
}

export default function EntityInfo({ title, data }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography
        variant="h4"
        component="h3"
        className={classes.name}
      >
        {title}
      </Typography>

      <Grid container>
        {
          data.map((item) => (
            <Grid item key={item.label} className={classes.itemContainer}>
              <Box mt={2}>
                <Info
                  caption={item.label}
                  value={item.value}
                  dataXPathConfig={item.dataXpath}
                />
              </Box>
            </Grid>
          ))
        }
      </Grid>
    </div>
  );
}
